import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import SolutionsDataContext from 'contexts/SolutionsDataContext';
import {SolutionsData} from 'models/app';

export type WithSolutionsDataProps = {
    solutionsData: SolutionsData;
};

export default function withSolutionsData<T extends WithSolutionsDataProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithSolutionsData extends React.Component<Omit<T, keyof WithSolutionsDataProps>> {
        static displayName = `withSolutionsData(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = SolutionsDataContext;

        render() {
            return <WrappedComponent {...(this.props as T)} solutionsData={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithSolutionsData, WrappedComponent);
    return WithSolutionsData;
}
